/**
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *  OKNO PULPITU POD ROZDZIELCZOŚĆ MASZYNY.
 *
 *  ⚠️⚠️ ZAMÓWIONE 15.09.2026: „mogłoby też robić w pionie resize do rozdzielczości maszyny".
 *  Powód jest zmierzony, a nie estetyczny: automat PESA-3 melduje 1080×1920, czyli ekran STOJĄCY.
 *  Okno otwierane na sztywno 1100×760 pokazywało wtedy pionowy obraz wciśnięty w poziomą ramkę —
 *  realnie kilkanaście procent powierzchni okna na obraz i dwa szerokie czarne pasy po bokach.
 *
 *  ⚠️ LICZYMY OD WNĘTRZA, NIE OD RAMKI. `window.resizeTo` ustawia rozmiar ZEWNĘTRZNY, a obraz
 *  dostaje wnętrze — więc ozdoby okna (pasek adresu, ramka) trzeba dodać na końcu, a przy
 *  sprawdzaniu, czy się mieści, odjąć na początku. Pomylenie tych dwóch daje okno o kilkadziesiąt
 *  pikseli za wysokie, które system po cichu przycina.
 *
 *  ⚠️ NIGDY NIE POWIĘKSZAMY PONAD ROZDZIELCZOŚĆ MASZYNY (`skala ≤ 1`). Rozciągnięty obraz 1:1
 *  nie niesie ani jednego piksela więcej, a kosztuje tyle samo łącza i rozmazuje tekst SPSUI.
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 */
export type Rozmiar = { szerokosc: number; wysokosc: number };

/** Ile pikseli okna zjadają ozdoby przeglądarki: `outer - inner` w obu osiach. */
export type Ozdoby = { szerokosc: number; wysokosc: number };

export function rozmiarOknaPulpitu(
  maszyna: Rozmiar,
  dostepne: Rozmiar,
  ozdoby: Ozdoby,
  pasekSkrotowPx: number,
): Rozmiar | null {
  const poprawne = (r: Rozmiar): boolean =>
    Number.isFinite(r.szerokosc) && Number.isFinite(r.wysokosc) && r.szerokosc > 0 && r.wysokosc > 0;
  if (!poprawne(maszyna) || !poprawne(dostepne)) return null;

  const ozdobyW = Math.max(0, ozdoby.szerokosc);
  const ozdobyH = Math.max(0, ozdoby.wysokosc);

  /** Wnętrze, które da się w ogóle dostać na tym ekranie — bez ozdób i bez paska skrótów. */
  const wnetrzeMaxW = dostepne.szerokosc - ozdobyW - pasekSkrotowPx;
  const wnetrzeMaxH = dostepne.wysokosc - ozdobyH;
  if (wnetrzeMaxW <= 0 || wnetrzeMaxH <= 0) return null;

  const skala = Math.min(wnetrzeMaxW / maszyna.szerokosc, wnetrzeMaxH / maszyna.wysokosc, 1);
  const obrazW = Math.round(maszyna.szerokosc * skala);
  const obrazH = Math.round(maszyna.wysokosc * skala);

  return {
    szerokosc: obrazW + pasekSkrotowPx + ozdobyW,
    wysokosc: obrazH + ozdobyH,
  };
}
